/**
 * @file: 层板对齐快捷方式
 * @author: xiaolong.huang@dmall.com
 */

import ShortCutKey from '../../interaction/shortcutkey/index';
import Modal from '../../interaction/modal';

function init(): void {
    ShortCutKey.on({
        keyName: 'dblclick',
        callback: (ev: Event) => {
            Modal.show(ev);
        }
    });
}

export default {
    init
};
